import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Facebook, Instagram, Youtube } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';

const LOGO_URL = 'https://caltavuturoclimbing.it/api/uploads/20260429172156_6a64f40e.png ';

export function Footer() {
  const { t } = useLanguage();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0A0A0A] text-white" data-testid="footer">
      <div className="container-custom py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Logo & Description */}
          <div className="lg:col-span-1">
            <img 
              src={LOGO_URL} 
              alt="Caltavuturo Climbing" 
              className="h-16 w-auto mb-6"
            />
            <p className="text-gray-400 text-sm leading-relaxed">
              {t('footerText')}
            </p>
            {/* Social Links */}
            <div className="flex space-x-4 mt-6">
              <a href="https://www.facebook.com/caltaclimbing" target="_blank" className="text-gray-400 hover:text-[#FF6D00] transition-colors" aria-label="Facebook">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="https://www.instagram.com/caltavuturo_climbing/ " target="_blank" className="text-gray-400 hover:text-[#FF6D00] transition-colors" aria-label="Instagram">
                <Instagram className="w-5 h-5" />
              </a>
            {/*  <a href="" target="_blank" className="text-gray-400 hover:text-[#FF6D00] transition-colors" aria-label="YouTube">
                <Youtube className="w-5 h-5" />
              </a> */}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-lg uppercase tracking-wider mb-6">Link Rapidi</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-gray-400 hover:text-[#FF6D00] transition-colors text-sm">
                  {t('home')}
                </Link>
              </li>
              <li>
                <Link to="/team/about" className="text-gray-400 hover:text-[#FF6D00] transition-colors text-sm">
                  {t('aboutUs')}
                </Link>
              </li>
              <li>
                <Link to="/crags/gazzara" className="text-gray-400 hover:text-[#FF6D00] transition-colors text-sm">
                  {t('crags')}
                </Link>
              </li>
              <li>
                <Link to="/team/events" className="text-gray-400 hover:text-[#FF6D00] transition-colors text-sm">
                  {t('events')}
                </Link>
              </li>
              <li>
                <Link to="/donations" className="text-gray-400 hover:text-[#FF6D00] transition-colors text-sm">
                  {t('donations')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Crags */}
          <div>
            <h4 className="font-heading text-lg uppercase tracking-wider mb-6">{t('crags')}</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/crags/gazzara" className="text-gray-400 hover:text-[#FF6D00] transition-colors text-sm">
                  Falesia di Gazzara
                </Link>
              </li>
              <li>
                <Link to="/crags/cabeci" className="text-gray-400 hover:text-[#FF6D00] transition-colors text-sm">
                  Falesia di Cabeci
                </Link>
              </li>
              <li>
                <Link to="/crags/rocca-piccola" className="text-gray-400 hover:text-[#FF6D00] transition-colors text-sm">
                  Falesia Rocca Piccola
                </Link>
              </li>
              <li>
                <Link to="/crags/rocca-di-sciara" className="text-gray-400 hover:text-[#FF6D00] transition-colors text-sm">
                  Falesia Rocca di Sciara
                </Link>
              </li>
              <li>
                <Link to="/crags/via-del-gatto" className="text-gray-400 hover:text-[#FF6D00] transition-colors text-sm">
                  Falesia Via del Gatto
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-heading text-lg uppercase tracking-wider mb-6">{t('contact')}</h4>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-[#FF6D00] flex-shrink-0 mt-0.5" />
                <span className="text-gray-400 text-sm">
                  Via Dante Alighieri 23<br />
                  90022 Caltavuturo (PA)<br />
                  Italia
                </span>
              </li>
              <li className="flex items-center space-x-3">
                <Phone className="w-5 h-5 text-[#FF6D00] flex-shrink-0" />
                <span className="text-gray-400 text-sm">
                  Carlo: +39 379 1243094
                </span>
              </li>
              <li className="flex items-center space-x-3">
                <Mail className="w-5 h-5 text-[#FF6D00] flex-shrink-0" />
                <a href="mailto:info@caltavuturoclimbing.it" className="text-gray-400 hover:text-[#FF6D00] transition-colors text-sm">
                  info@caltavuturoclimbing.it
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-500 text-sm">
            © {currentYear} Caltavuturo Climbing. Tutti i diritti riservati.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <Link to="/privacy" className="text-gray-500 hover:text-gray-400 text-sm">
              Privacy Policy
            </Link>
            <Link to="/cookie" className="text-gray-500 hover:text-gray-400 text-sm">
              Cookie Policy
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
